import { Component, Input, OnInit, Inject } from '@angular/core';
import { ServiceInsightsService } from '../../services/service-insights-service.service';
import { FiltersService } from 'src/app/core/services/filters.service';
import { Subscription } from 'rxjs';
import * as _ from 'lodash';
import { graphic } from 'echarts';
import { SICallTypesColorCode, PestServiceInsightsCallData, PestTotalCallsByTypeData, ServiceInsightRecord, ServiceMetricTypes, SICallTypes, SICallTypesDatabaseCode, TotalCallsInsightModel, ServiceInsightsCallData } from '../../types/service-insight-types';
import { ContractModel } from 'src/app/global/contract-filter-model';
import { CallTypeConfig } from 'src/app/features/solution-participation-details/types/solution-participation-types';
import { FEATURE_FLAGS, FeatureFlags } from 'src/app/config/AppInitializer.factory';
import { ServiceCustomerFilterOptions } from 'src/app/global/service-customer-model';

/**
 * @deprecated This component has been deprecated and will be removed in future versions in favor of Neptune UI.
 */
@Component({
    selector: 'app-service-metric-donut-chart',
    templateUrl: './service-metric-donut-chart.component.html',
    styleUrls: ['./service-metric-donut-chart.component.scss'],
    standalone: false
})
export class ServiceMetricDonutChartComponent implements OnInit {

  @Input() division = 'Institutional';
  @Input() serviceType: ServiceMetricTypes = ServiceMetricTypes.Calls;
  @Input() title:  string = 'Total Calls';

  //expose enum for html
  ServiceMetricTypes = ServiceMetricTypes;

  chartOptions!: any;
  lineChartOptions!: any;

  filters: ContractModel | undefined;

  //chart data
  lineChartData : ServiceInsightRecord[] | undefined;
  donutChartData : TotalCallsInsightModel[] | undefined;

  textColor = '#39B54A';

  totalCount : number = 0;
  prevTotalCount: number = 0;

  growth: number | null = null;
  growthDateRangeAvailable: boolean = false;

  negativeGrowth : boolean = false;

  series : any | undefined;

  xAxis : any[] | undefined;
  yAxis : any[] | undefined;

  checked: boolean = false;

  selectAllSubscription: Subscription | undefined;

  displayLoader: boolean = true;
  testKey :SICallTypes = SICallTypes.TotalCalls;
  //types[] should map exactly to the callReason property in api response
  // Use a runtime getter so Audit vs ProgramReviews can be chosen by feature flag
  private getCallTypeConfig(): CallTypeConfig {
    const programOrAuditMetricType: keyof ServiceInsightsCallData =
      ((this.filters?.division === 'QSR' && this._featureFlags?.enableAuditMetricForQSR) ||
       (this.filters?.division === 'FRS' && this._featureFlags?.enableAuditMetricForFRS))
        ? SICallTypes.Audit
        : SICallTypes.ProgramReviews;

    return {
      Institutional_Calls: {
        types: [SICallTypesDatabaseCode[SICallTypes.ExtraServiceVisit], SICallTypesDatabaseCode[SICallTypes.ProgramReviews], SICallTypesDatabaseCode[SICallTypes.TrainingSessions], SICallTypesDatabaseCode[SICallTypes.RegularServiceCalls], SICallTypesDatabaseCode[SICallTypes.Installations], SICallTypesDatabaseCode[SICallTypes.QuickCalls]],
        colors: [SICallTypesColorCode[SICallTypes.ExtraServiceVisit], SICallTypesColorCode[SICallTypes.ProgramReviews], SICallTypesColorCode[SICallTypes.TrainingSessions], SICallTypesColorCode[SICallTypes.RegularServiceCalls], SICallTypesColorCode[SICallTypes.Installations], SICallTypesColorCode[SICallTypes.QuickCalls]]
      },
      Pest_Services: {
        types: [SICallTypesDatabaseCode[SICallTypes.ContractedCleanOut], SICallTypesDatabaseCode[SICallTypes.ExtraOneShot], SICallTypesDatabaseCode[SICallTypes.ContractedRegular], SICallTypesDatabaseCode[SICallTypes.ExtraFollowUp]],
        colors: [SICallTypesColorCode[SICallTypes.ContractedCleanOut], SICallTypesColorCode[SICallTypes.ExtraOneShot], SICallTypesColorCode[SICallTypes.ContractedRegular], SICallTypesColorCode[SICallTypes.ExtraFollowUp]]
      },
      Pest_Findings: {
        types: [SICallTypesDatabaseCode[SICallTypes.Pest], SICallTypesDatabaseCode[SICallTypes.Sanitation], SICallTypesDatabaseCode[SICallTypes.Structural], SICallTypesDatabaseCode[SICallTypes.Prep]],
        colors: [SICallTypesColorCode[SICallTypes.Pest], SICallTypesColorCode[SICallTypes.Sanitation], SICallTypesColorCode[SICallTypes.Structural], SICallTypesColorCode[SICallTypes.Prep]]
      },
      Pest_CallsByReason: {
        types: ['PEST ESR', 'NON-PEST ESR', 'PLEASE CALL', 'NO SHOW\/NO RESPONSE', 'INFORMATION', 'ALL OTHER'],
        colors: ['#006bd3', '#813b9e', '#1aa5e0', '#39b54a', '#4fc2b0', '#ecc42f']
      },
      QSR_Calls: {
        types: [SICallTypesDatabaseCode[SICallTypes.ExtraServiceVisit], SICallTypesDatabaseCode[programOrAuditMetricType], SICallTypesDatabaseCode[SICallTypes.TrainingSessions], SICallTypesDatabaseCode[SICallTypes.RegularServiceCalls], SICallTypesDatabaseCode[SICallTypes.Installations], SICallTypesDatabaseCode[SICallTypes.QuickCalls]],
        colors: [SICallTypesColorCode[SICallTypes.ExtraServiceVisit], SICallTypesColorCode[programOrAuditMetricType], SICallTypesColorCode[SICallTypes.TrainingSessions], SICallTypesColorCode[SICallTypes.RegularServiceCalls], SICallTypesColorCode[SICallTypes.Installations], SICallTypesColorCode[SICallTypes.QuickCalls]]
      },
      FRS_Calls: {
        types: [SICallTypesDatabaseCode[SICallTypes.ExtraServiceVisit], SICallTypesDatabaseCode[programOrAuditMetricType], SICallTypesDatabaseCode[SICallTypes.TrainingSessions], SICallTypesDatabaseCode[SICallTypes.RegularServiceCalls], SICallTypesDatabaseCode[SICallTypes.Installations], SICallTypesDatabaseCode[SICallTypes.QuickCalls]],
        colors: [SICallTypesColorCode[SICallTypes.ExtraServiceVisit], SICallTypesColorCode[programOrAuditMetricType], SICallTypesColorCode[SICallTypes.TrainingSessions], SICallTypesColorCode[SICallTypes.RegularServiceCalls], SICallTypesColorCode[SICallTypes.Installations], SICallTypesColorCode[SICallTypes.QuickCalls]]
      }
    };
  }

  selectedAdvancedFilters: ServiceCustomerFilterOptions = {
    "accountNumber": [],
    "accountName": [],
    "country": [],
    "state": [],
    "city": [],
    "zipCode": [],
    "recurringIssue": [],
   };

  serviceCustomerFiltersSubscription: Subscription| undefined;

  constructor(private _serviceInsightsService: ServiceInsightsService,
    private _filterService: FiltersService,
    @Inject(FEATURE_FLAGS) private _featureFlags: FeatureFlags) { }

  async ngOnInit(): Promise<void> {
    this.selectedAdvancedFilters = {
      "accountNumber": [],
      "accountName": [],
      "country": [],
      "state": [],
      "city": [],
      "zipCode": [],
      "recurringIssue": [],
     };

     // Get the filters selected
    this._filterService.selectedFiltersObservable.subscribe(f => this.filters = f);

    if (this.filters != undefined) {
      this.selectAllSubscription = this._serviceInsightsService.isAllSelected.subscribe(allSelected => {
        this.checked = allSelected;
        this._onCheckedChange(this.checked);
      });

      //Added this condition because no advance filters are available for Pest
      if(this.division !== 'Pest') {
        this.serviceCustomerFiltersSubscription = this._serviceInsightsService.getServiceCustomerFilters().subscribe(async advFilter => {
          this.selectedAdvancedFilters = advFilter;
        });
      }

      this.displayLoader = true;
      if(this.division==='Pest') {
        this.subscribeToPestServiceData();
        await this.loadPestServiceData();
      }else{ //Institutional Contract
        this.subscribeToServiceData();
        await this.loadContractServiceData();
      }

      this.updateCharts();
      this.displayLoader = false;
    }
  }

  isTotalCallsByTypeDataEmpty () { return this.donutChartData?.length === 0; }
  isTotalCallsByPeriodDataEmpty () { return this.lineChartData?.length === 0; }

  subscribeToPestServiceData() {
    this._serviceInsightsService.getPestTotalCallsByTypeData(`${this.serviceType}-total-calls` as keyof PestTotalCallsByTypeData).subscribe(
      f => {
        this.donutChartData = f.totalCalls;
      }
    );

    this._serviceInsightsService.getPestServiceInsightsCallData(`${this.serviceType}-total-calls` as keyof PestServiceInsightsCallData).subscribe(
      f => {
        this.lineChartData = f.periods;
        this.growth = f.percentChangeInCount;
      }
    );
  }

  subscribeToServiceData() {
    //get the total calls by type data
    this._serviceInsightsService.getTotalCallsByTypeData().subscribe(
      f => {
        this.donutChartData = f.totalCalls;
      }
    );

    //get the total calls by period data
    this._serviceInsightsService.getServiceInsightsCallData(SICallTypes.TotalCalls).subscribe(
      f => {
        this.lineChartData = f.periods;
        this.growth = f.percentChangeInCount;
      }
    );
  }

  async loadPestServiceData(){
    //if subscriptions are empty, call api and set the subscriptions
    if (this.isTotalCallsByTypeDataEmpty()) {
      this._serviceInsightsService.setPestTotalCallsByTypeData(
         `${this.serviceType}-total-calls` as keyof PestTotalCallsByTypeData,
        await this._serviceInsightsService.getTotalCallsByTypeFromAPI(this.serviceType, this.selectedAdvancedFilters)
      );
    }

    if (this.isTotalCallsByPeriodDataEmpty()) {
      this._serviceInsightsService.setPestServiceInsightsCallData(
        `${this.serviceType}-total-calls` as keyof PestServiceInsightsCallData,
        await this._serviceInsightsService.getSIMetricByPeriodFromAPI(this.serviceType, SICallTypes.TotalCalls, this.selectedAdvancedFilters)
      );
    }
  }

  async loadContractServiceData(){
    //if subscriptions are empty, call api and set the subscriptions
    if (this.isTotalCallsByTypeDataEmpty()) {
      this._serviceInsightsService.setTotalCallsByTypeData(
        await this._serviceInsightsService.getTotalCallsByTypeFromAPI(this.serviceType, this.selectedAdvancedFilters)
      );
    }

    if (this.isTotalCallsByPeriodDataEmpty()) {
      this._serviceInsightsService.setServiceInsightsCallData(
        SICallTypes.TotalCalls,
        await this._serviceInsightsService.getSIMetricByPeriodFromAPI(this.serviceType, SICallTypes.TotalCalls, this.selectedAdvancedFilters)
      );
    }
  }

  updateCharts() {
    if (this.donutChartData != undefined) {
      this.totalCount = this.donutChartData?.reduce((sum, curr) => sum + curr.total, 0) as number;
      this._setDonutSeries();
      this.setOptions();
      this._onCheckedChange(this.checked);
    }

    if (this.lineChartData != undefined) {
      this._fillXandYAxis();
      this.setLineChartOptions();
      if (this.totalCount != undefined) {
        this._onCheckedChange(this.checked);
      }
    }

    this.growthDateRangeAvailable = this._filterService.IsPreviousPeriodAvailable();

    if (this.growth != null) {
      this.setGrowth();
    }
}

  setOptions() {
    const serviceUnit = this.serviceType === ServiceMetricTypes.CallsByReason ? "Calls" : this.serviceType;
    const division = this.filters?.division || 'Institutional';
    this.chartOptions = {
      renderer: 'svg', // Specify SVG renderer
      tooltip:{
          trigger:'item',
          formatter: (params : any) => {
            return `
            <div style="display:block;">
              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                <circle cx="6" cy="6" r="6" fill="${params.color}"/>
              </svg>
              ${params.data.name}<br/>
              <div style="gap:8px; margin-top:8px; margin-bottom:8px;">
                <span class="percent-calls-tooltip" style="font-size:30px; color:#313233;">${params.percent}%</span>
                <span style="font-size:12px; color:#8E9393">of total ${serviceUnit}</span>
                <span style="font-size:12px; color:#8E9393; display:block; margin-bottom:0em;">${params.data.value}</span>
                <span style="font-size:12px; color:#8E9393; display:block; margin-bottom:0em; margin-top:0em;">across ${params.data.totalLocations} locations</span>
              </div>
            </div>
              `;
          },
        },
      series: [
        {
          type: 'pie',
          data: this.series,
          radius: ['47%', '66%'],
          label: {
            show: false
          },
          color: this.getCallTypeConfig()[`${division}_${this.serviceType}`].colors,
          itemStyle: {
            borderWidth: 5,
            borderColor: '#F7F7F7'
          },
          center: ['50%', '35%']
        },

      ],
      legend: [
        {
          data: this.series,
          icon: 'circle',
          left: 'center',
          bottom: 30,
          orient: this.serviceType === ServiceMetricTypes.CallsByReason ? 'vertical' : (division === "Pest" ? 'horizontal' : 'vertical'),
          height: '80px',
          itemStyle: {
            borderWidth: 0,
          },
          textStyle: {
            color: '#313233',
            fontSize: 12,
            fontStyle: 'normal',
            fontWeight: 400,
            fontFamily: 'Roboto',
          }
        }
      ]
    }
  }

  private _fillXandYAxis(){
    if (this.lineChartData != undefined) {
      this.xAxis = this.lineChartData.map(record => record.endDate);
      this.yAxis = this.lineChartData.map(record => {return {'value': record.total, 'date': record.endDate, 'totalLocations': record.totalLocations}});
    }

  }

  //this is for the line chart directly beneath the donut chart
  setLineChartOptions(){
    this.lineChartOptions = {
        grid:{ //since we are not displaying the axis labels or legend, let graph take up entirety of canvas
          left:0,
          right:0,
          bottom:0,
          top:0
        },
        xAxis: {
            type: 'category',
            boundaryGap: false,
            data: this.xAxis,
            show:false
        },
        yAxis: {
            type: 'value',
            show:false,

        },
        tooltip:{
          trigger:'axis',
          formatter: (params : any) => {
            let date = new Date(params[0].data.date);
            const serviceUnit = this.serviceType === ServiceMetricTypes.CallsByReason ? "Calls" : this.serviceType;
            return `
              <div style="display:flex; align-items:bottom; gap:8px; ">
                <span class="total-calls-tooltip" style="font-size:30px; color:#313233;">${params[0].data.value}</span><span style="font-size:12px; color:#8E9393">total ${serviceUnit}</span>
              </div>
              <br/>
              <span style="color:#313233; font-weight=400; font-family:Roboto;"> ${date.toLocaleDateString('en-US', {month: "long", day: "numeric", year: "numeric"})}</span><br/>
              across ${params[0].data.totalLocations} locations
              `;
          }
        },
        lineStyle:{
          color:'#3AA3E2'
        },
        series: [{
            data: this.yAxis,
            type: 'line',
            symbol:'none',
            connectNulls:true,
            areaStyle: {
              color: new graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: 'rgba(26, 165, 224, 0.6)'
                },
                {
                  offset: 1,
                  color: 'rgba(26, 165, 224, 0)'
                }])
            }
        }]
    };
  }

  //function that runs when the checkbox is clicked
  _onCheckedChange(b : boolean) {
    const title = this.title === 'Total Services' ? 'Service Visits' : this.title;
    this.checked = b;
    if (this.totalCount != undefined) {
        if (this.checked && this.serviceType !== ServiceMetricTypes.Findings
          && this.serviceType !== ServiceMetricTypes.CallsByReason
        ) {
          this._serviceInsightsService.addMetricToPresentation(title, this.totalCount);
        }
        else{
          this._serviceInsightsService.removeMetricFromPresentation(title);
        }
        this._serviceInsightsService.setPestMetricsSelected(title, this.checked);
    }
  }

  _setDonutSeries() {
    const division = this.filters?.division || 'Institutional';
    const config = this.getCallTypeConfig()[`${division}_${this.serviceType}`];
    const callReasonOrder = config.types;
    const sortedData = new Array<any>(callReasonOrder.length).fill({"total": 0, "totalLocations": 0});


    if (this.donutChartData) {
      this.donutChartData.forEach(item => {
        const index = callReasonOrder.indexOf(item?.callReason);
        if (index !== -1) {
          sortedData[index] = item;
        }
      });
      // Ensure each category has a default value if not present
      sortedData.forEach((item, index) => {
        if (!item || item.callReason !== callReasonOrder[index]) {
           sortedData[index] = {"callReason": callReasonOrder[index], "total": 0, "totalLocations": 0};
        }
      });
    }
    this.series = sortedData?.map((item) => {
      return {
        'value': item.total,
        'name': this.filters?.division === 'Pest' ? this._serviceInsightsService.getPestServiceCallByCode(item.callReason) : this._serviceInsightsService.getServiceCallByCode(item.callReason),
        'totalLocations': item.totalLocations
      }
    });
  }

  setGrowth() {
    this.textColor = (this.growth != null && this.growth >= 0) ? '#39B54A' : '#DF3935';
    this.negativeGrowth = this.growth != null && this.growth < 0;
  }

  ngOnDestroy(): void {
    this.selectAllSubscription?.unsubscribe();
    this.serviceCustomerFiltersSubscription?.unsubscribe();
  }
}
